export const recurrentTableFields = [
  { key: 'weekNames', label: 'Wochentag' },
  { key: 'dateFrom', label: 'Startdatum', class: 'text-center' },
  { key: 'dateTo', label: 'Enddatum', class: 'text-center' },
  { key: 'timeFrom', label: 'Von', class: 'text-center' },
  { key: 'timeTo', label: 'Bis', class: 'text-center' },
  { key: 'activityType', label: 'Type', class: 'text-center' },
  { key: 'information', label: 'Information' },
  { key: 'function', label: 'function', class: 'text-center function' },
];